module.exports = __webpack_public_path__ + "media/images/users/purchases/rank_desc_en-aa3354edb730eaf62c63e05033ae1c1d.png";